import { Link } from "react-router-dom";

import Button from "../../../../components/button/button";
import FormUser from "../../../../components/forms/formUser";
import ArrowLeft from "../../../../assets/icons/arrow-left.svg";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";

const UserRegister = () => {
  return (
    <div>
      <HeaderTitle title="Cadastrar Usuário">
        <Link to="/app/usuarios">
          <Button
            icon={ArrowLeft}
            text="Voltar"
            size="normal"
            variation="outline"
          />
        </Link>
      </HeaderTitle>

      <div className="mainContentSpace">
        <FormUser />
      </div>
    </div>
  );
};

export default UserRegister;
